module.exports = {
      id: "bullet-arrow-usage",
      viewBox: "0 0 22 20",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#bullet-arrow",
      toString: function () {
        return this.url;
      }
    }